import { FunctionComponent } from 'react'
import styles from './showMoreLinkDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { EventCalendar } from '@/types/Calendar.ts'
import {
    compareEventsByTypeForAgendaViewDaycare,
    compareEventsByTypeForAgendaViewParent,
    renderEventAgendaView
} from '../../utils/calendarEvents.tsx'
import moment from 'moment/moment'
import { NavigateFunction, useNavigate } from 'react-router-dom'

interface ShowMoreLinkDialogProps {
    open: boolean
    handleClose: () => void
    events: EventCalendar[]
    date: string
    isParent: boolean
    handleEventClick: (info: EventCalendar) => void
    isGlobalPlanning: boolean
}

const ShowMoreLinkDialog: FunctionComponent<ShowMoreLinkDialogProps> = ({
    open,
    handleClose,
    events,
    date,
    isParent,
    handleEventClick,
    isGlobalPlanning
}: ShowMoreLinkDialogProps) => {
    const navigate: NavigateFunction = useNavigate()

    function selectEvent(event: EventCalendar): void {
        if (isGlobalPlanning) {
            navigate(`/drafting?id=${event.sectionGroupId}&date=${moment(event.start).format('DD-MM-YYYY')}`)
        } else {
            handleEventClick(event)
        }
    }

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={date} parent={isParent} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.Container}>
                    {[...events]
                        .sort(
                            isParent ? compareEventsByTypeForAgendaViewParent : compareEventsByTypeForAgendaViewDaycare
                        )
                        .map((event: EventCalendar, index: number) => (
                            <div key={index} className={styles.renderEvent}>
                                {renderEventAgendaView(event, selectEvent)}
                            </div>
                        ))}
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} parent={isParent} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ShowMoreLinkDialog
